const nonAuthenticatedPaths = {
  LOGIN: '/login'
}

const authenticatedPaths = {
  HOME: '/home',
  GENERATOR: '/',
  GRAPHICS: '/grafiki',
  GRAPHICS_ID: '/grafiki/:id',
  VIEWERS: '/wyswietlacze'
}

/**
 * Object containing paths for the router.
 */
const paths = {
  ...nonAuthenticatedPaths,
  ...authenticatedPaths
}

export default paths
